import React from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router'

function FooterPages() {
    const navigate = useNavigate()
    const location = useLocation()
  return (
    <div class="container-fluid copybg">
    <div class="container mycontainer">
        <div class="row">
          <div class="col-md-11 col-sm-11 col-xs-12">
              <img src="../Assets/Images/copyimg.webp" class="max" alt="Revenue Radar"/><br/>©2023 Quation Solutions Pvt. Ltd., All rights reserved
          </div>
          <div class="col-md-1 col-sm-1 col-xs-12">
            <p id="bottom">
                {/* <a href="javascript:scrollToTop()" aria-label="DE">
                  <iconify-icon icon="tabler:arrow-top-circle" class="scrollerbottom animate__animated animate__infinite animate__slideInUp"></iconify-icon>
                </a> */}
            </p>
        </div>
        </div>
    </div>
  </div>
  )
}

export default FooterPages